import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verification SPPO by Role ID and User ID
export const getVerificationSPPO = async (roleId, userId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetVerificationSPPO?RoleId=${roleId}&Userid=${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get SPPO by Number for Verification
export const getSPPObyNoForVerify = async (sppono, ccCode, vendorCode, amendId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetSPPObyNoForVerify?Sppono=${sppono}&CCCode=${ccCode}&VendorCode=${vendorCode}&AmendId=${amendId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve SPPO
export const approveSPPO = async (approvalData) => {
    try {
        
        // Log a sample of the data being sent
        
        const response = await axios.put(
            `${API_BASE_URL}/Purchase/ApproveSPPO`,
            approvalData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000 // 30 second timeout for complex operations
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
            // Server responded with error status
            
            // Log specific error details for 400 errors
            if (error.response.status === 400) {
            }
            
        } else if (error.request) {
            // Request was made but no response received
        } else {
            // Something else happened
        }
        
        
        // Return more specific error information
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid data format or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};
